import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Sidebar from './components/Layout/Sidebar';
import Header from './components/Layout/Header';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Purchases from './components/Purchases';
import Aggregation from './components/Aggregation';
import Discounts from './components/Discounts';
import Members from './components/Members';
import Brands from './components/Brands';
import Groups from './components/Groups';
import Suppliers from './components/Suppliers';
import Financials from './components/Financials';
import TrialBalance from './components/TrialBalance';
import JournalEntries from './components/JournalEntries';
import Tax from './components/Tax';
import MonthEnd from './components/MonthEnd';
import Reconciliation from './components/Reconciliation';
import FixedAssets from './components/FixedAssets';
import Ageing from './components/Ageing';
import ChatWidget from './components/ChatWidget';
import './App.css';

function AppContent() {
  const { user, logout } = useAuth();
  const [navOpen, setNavOpen] = useState(false);

  if (!user) {
    return <Login />;
  }

  return (
    <div className={`app${navOpen ? ' nav-open' : ''}`}>
      <div
        className="nav-backdrop"
        role="presentation"
        onClick={() => setNavOpen(false)}
        aria-hidden={!navOpen}
      />
      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />
      <div className="main">
        <Header
          user={user}
          onLogout={logout}
          onMenuToggle={() => setNavOpen((v) => !v)}
        />
        <div className="content">
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/purchases" element={<Purchases />} />
            <Route path="/aggregation" element={<Aggregation />} />
            <Route path="/discounts" element={<Discounts />} />
            <Route path="/members" element={<Members />} />
            <Route path="/brands" element={<Brands />} />
            <Route path="/groups" element={<Groups />} />
            <Route path="/suppliers" element={<Suppliers />} />
            <Route path="/financials" element={<Financials />} />
            <Route path="/trial-balance" element={<TrialBalance />} />
            <Route path="/journal-entries" element={<JournalEntries />} />
            <Route path="/tax" element={<Tax />} />
            <Route path="/month-end" element={<MonthEnd />} />
            <Route path="/reconciliation" element={<Reconciliation />} />
            <Route path="/fixed-assets" element={<FixedAssets />} />
            <Route path="/ageing" element={<Ageing />} />
            <Route path="/" element={<Navigate to="/dashboard" />} />
          </Routes>
        </div>
        <ChatWidget />
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
